module.exports = __webpack_public_path__ + "static/fonts/NeoSansPro-Italic.b2efdb9.ttf";